const DATE_FIELDS = ["birthdate", "currentInsuranceExpiration"];

export const transformDateFormat = (date: string): string => {
  if (!/\d{2}\/\d{2}\/\d{4}/.test(date)) {
    throw new Error(
      "transformDateFormat function expect a date string with format DD/MM/YYYY as input"
    );
  }

  const [day, month, year] = date.split("/");
  return `${month}/${day}/${year}`;
};

export const parseDateFields = data =>
  DATE_FIELDS.filter(field => data[field])
    .map(field => ({ [field]: new Date(transformDateFormat(data[field])) }))
    .reduce((accum, dates) => ({ ...accum, ...dates }), data);

export const fixAttribution = data => ({
  ...data,
  attribution: data.attribution.pageView
});

export const transformMutationData = (mutateFn: MutationFunction) => data => {
  const form = fixAttribution(parseDateFields(data));
  return mutateFn({ variables: { form } });
};
